"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateTimeToString = transformDateTimeToString;
const utils_1 = require("@daytrip/utils");
const transformDateToString_1 = require("./transformDateToString");
function transformDateTimeToString(date, displayUTC, with24hoursFormat = false, showDayOfWeek = false) {
    let newDate = date;
    if (newDate instanceof Date) {
        newDate = newDate.getTime();
    }
    return `${(0, transformDateToString_1.transformDateToString)(newDate, showDayOfWeek)} ${(0, utils_1.transformTimeToString)(newDate, with24hoursFormat)}${displayUTC ? " UTC0" : ""}`;
}
//# sourceMappingURL=transformDateTimeToString.js.map